import React, { useEffect, useState } from 'react';
// import 'antd/dist/antd.css';

import { Input, Radio, message, Spin, Modal, Button, Row, Col, Form } from 'antd';
import CKEditorUtil from '../../../../utils/ckEditorUtil'
import efn from './SubmissionNoteUpsertPageFns'
import moment from 'moment';

function SubmissionNoteUpsertPage(props) {
  const { lang, submissionNoteMap } = props
  const [form] = Form.useForm();
  const { TextArea } = Input
  const [langSubmissionNote, setLangSubmissionNote] = useState()
  const [editorData, setEditorData] = useState();
  let setFuncMap = { setLangSubmissionNote, setEditorData, ...props.setFuncMap }
  const onFinish = values => {
    values["lang"] = lang
    values["content"] = editorData
    efn.updateSubmissionNote(values, props, setFuncMap)
  };

  useEffect(() => {
    setLangSubmissionNote(submissionNoteMap[lang])
    form.setFieldsValue(submissionNoteMap[lang])
  }, [submissionNoteMap])

  useEffect(() => {
    form.setFieldsValue(langSubmissionNote)
  }, [langSubmissionNote])

  return (
    <Form
      form={form}
      layout="horizontal"
      onFinish={onFinish}
    >
      <CKEditorUtil setFuncMap={setFuncMap} defaultValue={langSubmissionNote ? langSubmissionNote.content : null} />
      <Form.Item
        name="id"
        hidden
      >
        <Input type="hidden" />{langSubmissionNote && langSubmissionNote.lastUpdateAt && `最後更新時間: ${moment(langSubmissionNote.lastUpdateAt).format("yyyy-MM-DD HH:mm:ss")}`}
      </Form.Item>
      <Row justify={"center"} gutter={16}>
        <Col>
          <Button type="primary" htmlType="submit">
            更新
          </Button>
        </Col>
      </Row>

    </Form>
  );
}



export default React.memo(SubmissionNoteUpsertPage);
